import { Project } from '../types/project'

export const projects: Project[] = [
  // Active Website Projects
  {
    id: 'proj-1',
    company_id: 'wf',
    title: 'GarrettAuto.com',
    completed: false,
    value: 1500,
    contact_id: 'contact-wf-1',
    tasks: [
      { id: 'task-1', title: 'Design Changes', completed: false, value: 0 },
      { id: 'task-2', title: 'Apply Design', completed: false, value: 0 },
    ],
    notes: [],
    created_at: new Date('2024-01-15'),
    updated_at: new Date('2024-01-23'),
  },
  {
    id: 'proj-2',
    company_id: 'wf',
    title: '5thStreetBranding.com',
    completed: false,
    value: 0,
    contact_id: 'contact-wf-2',
    tasks: [
      { id: 'task-5', title: 'Final Tweaks', completed: false, value: 0 },
      { id: 'task-6', title: 'Go Live', completed: false, value: 0 },
    ],
    notes: [
      {
        id: 'note-5th-1',
        text: 'OrderMyGear Code',
        created_at: new Date('2024-01-22'),
      },
    ],
    created_at: new Date('2024-01-10'),
    updated_at: new Date('2024-01-22'),
  },
  {
    id: 'proj-3',
    company_id: 'wf',
    title: 'SamsDisposal.com',
    completed: false,
    value: 5000,
    tasks: [
      { id: 'task-9', title: 'Follow Up SEO', completed: false, value: 0 },
      { id: 'task-10', title: 'Shane Call', completed: false, value: 0 },
    ],
    notes: [],
    created_at: new Date('2024-01-08'),
    updated_at: new Date('2024-01-21'),
  },
  {
    id: 'proj-4',
    company_id: 'wf',
    title: 'CustomUniformSupplier.com',
    completed: false,
    value: 0,
    tasks: [
      { id: 'task-13', title: 'AI Pages', completed: false, value: 0 },
      { id: 'task-14', title: 'Twilio', completed: false, value: 0 },
      { id: 'task-15', title: 'Setup BOT', completed: false, value: 0 },
      { id: 'task-16', title: 'Shane FUP', completed: false, value: 0 },
    ],
    notes: [],
    created_at: new Date('2024-01-05'),
    updated_at: new Date('2024-01-20'),
  },
  {
    id: 'proj-5',
    company_id: 'wf',
    title: 'Teamsntees.com',
    completed: false,
    value: 150,
    contact_id: 'contact-wf-3',
    tasks: [
      { id: 'task-17', title: 'Add Categories', completed: false, value: 0 },
      { id: 'task-18', title: 'Finalize Nav', completed: false, value: 0 },
      { id: 'task-19', title: 'Apply Design', completed: false, value: 0 },
      {
        id: 'task-20',
        title: 'Setup Card Processor',
        completed: false,
        value: 0,
      },
      { id: 'task-21', title: 'Shipping Setup', completed: false, value: 0 },
      { id: 'task-22', title: 'Twilio Setup', completed: false, value: 0 },
      { id: 'task-23', title: 'Bot Build', completed: false, value: 0 },
      { id: 'task-24', title: 'Shane FUP', completed: false, value: 0 },
    ],
    notes: [],
    created_at: new Date('2024-01-12'),
    updated_at: new Date('2024-01-24'),
  },
  {
    id: 'proj-6',
    company_id: 'wf',
    title: 'PrecisionProSprayers.com',
    completed: false,
    value: 1000,
    tasks: [
      { id: 'task-25', title: 'Apply Design', completed: false, value: 0 },
      { id: 'task-26', title: 'Setup Ecommerce', completed: false, value: 0 },
      { id: 'task-27', title: 'Twilio Setup', completed: false, value: 0 },
      { id: 'task-28', title: 'Bots', completed: false, value: 0 },
      { id: 'task-29', title: 'Stripe setup', completed: false, value: 0 },
      { id: 'task-30', title: 'Shane FUP', completed: false, value: 0 },
    ],
    notes: [],
    created_at: new Date('2024-01-18'),
    updated_at: new Date('2024-01-23'),
  },
  {
    id: 'proj-7',
    company_id: 'wf',
    title: 'ChekoMartialArts.com',
    completed: false,
    value: 1000,
    tasks: [
      {
        id: 'task-31',
        title: 'Waiting for approval',
        completed: false,
        value: 0,
      },
      { id: 'task-32', title: 'Apply Design', completed: false, value: 0 },
      { id: 'task-33', title: 'Setup BOTS', completed: false, value: 0 },
      { id: 'task-34', title: 'Twilio Setup', completed: false, value: 0 },
      {
        id: 'task-35',
        title: 'Shane FUP on FB ads',
        completed: false,
        value: 0,
      },
    ],
    notes: [],
    created_at: new Date('2024-01-14'),
    updated_at: new Date('2024-01-22'),
  },
  {
    id: 'proj-8',
    company_id: 'wf',
    title: 'DesertSageSeminars.com',
    completed: false,
    value: 8200,
    tasks: [
      {
        id: 'task-36',
        title: 'Review Changes and repeat',
        completed: false,
        value: 0,
      },
      { id: 'task-37', title: 'Apply Design', completed: false, value: 0 },
      {
        id: 'task-38',
        title: 'Shane Prototype Back End',
        completed: false,
        value: 0,
      },
    ],
    notes: [],
    created_at: new Date('2024-01-16'),
    updated_at: new Date('2024-01-24'),
  },
  {
    id: 'proj-9',
    company_id: 'wf',
    title: 'NWBlackBelt.com - apply new MP design',
    completed: false,
    value: 150,
    tasks: [
      { id: 'task-39', title: 'Apply Design', completed: false, value: 0 },
      {
        id: 'task-40',
        title: 'Update BOT and Live chat',
        completed: false,
        value: 0,
      },
      {
        id: 'task-41',
        title: 'Shane FUP with FB ads',
        completed: false,
        value: 0,
      },
    ],
    notes: [],
    created_at: new Date('2024-01-20'),
    updated_at: new Date('2024-01-24'),
  },
  {
    id: 'proj-10',
    company_id: 'wf',
    title: 'MashGym.com - New MP design',
    completed: false,
    value: 1000,
    tasks: [
      { id: 'task-42', title: 'New design', completed: false, value: 0 },
      { id: 'task-43', title: 'Apply design', completed: false, value: 0 },
      { id: 'task-44', title: 'Update bots', completed: false, value: 0 },
    ],
    notes: [],
    created_at: new Date('2024-01-21'),
    updated_at: new Date('2024-01-24'),
  },

  // Additional Projects
  {
    id: 'proj-11',
    company_id: 'wf',
    title: 'WalkerKicks.com - Editing Free Site',
    completed: false,
    value: 150,
    tasks: [
      { id: 'task-45', title: 'Get him signed up', completed: false, value: 0 },
      { id: 'task-46', title: 'Configure Bots', completed: false, value: 0 },
      { id: 'task-47', title: 'Setup Twilio', completed: false, value: 0 },
      {
        id: 'task-48',
        title: 'Shane FUP Facebook ads',
        completed: false,
        value: 0,
      },
    ],
    notes: [],
    created_at: new Date('2024-01-22'),
    updated_at: new Date('2024-01-24'),
  },
  {
    id: 'proj-12',
    company_id: 'wf',
    title: 'Wearhaus.net - send $1000 redesign',
    completed: false,
    value: 1000,
    tasks: [
      { id: 'task-49', title: 'New design', completed: false, value: 0 },
      { id: 'task-50', title: 'Apply Design', completed: false, value: 0 },
      { id: 'task-51', title: 'Twilio Setup', completed: false, value: 0 },
      { id: 'task-52', title: 'Bot Setup', completed: false, value: 0 },
      { id: 'task-53', title: 'FUP Shane', completed: false, value: 0 },
      {
        id: 'task-54',
        title: 'FUP call for stores (like OrderMyGear, 5thStreet)',
        completed: false,
        value: 0,
      },
      {
        id: 'task-55',
        title: 'FUP call 3d proofing',
        completed: false,
        value: 0,
      },
    ],
    notes: [],
    created_at: new Date('2024-01-23'),
    updated_at: new Date('2024-01-24'),
  },
  {
    id: 'proj-13',
    company_id: 'wf',
    title: 'FUP call for stores',
    completed: false,
    value: 0,
    tasks: [
      {
        id: 'task-56',
        title: 'Schedule follow-up calls',
        completed: false,
        value: 0,
      },
      {
        id: 'task-57',
        title: 'Prepare presentation',
        completed: false,
        value: 0,
      },
      { id: 'task-58', title: 'Send proposals', completed: false, value: 0 },
    ],
    notes: [],
    created_at: new Date('2024-01-24'),
    updated_at: new Date('2024-01-24'),
  },
  {
    id: 'proj-15',
    company_id: 'wf',
    title: 'Echo AWS',
    completed: false,
    value: 50000,
    contact_id: 'contact-wf-4',
    tasks: [
      {
        id: 'task-62',
        title: 'Infrastructure setup',
        completed: false,
        value: 15000,
      },
      {
        id: 'task-63',
        title: 'Lambda functions',
        completed: false,
        value: 10000,
      },
      {
        id: 'task-64',
        title: 'API Gateway configuration',
        completed: false,
        value: 8000,
      },
      {
        id: 'task-65',
        title: 'Database migration',
        completed: false,
        value: 12000,
      },
      {
        id: 'task-66',
        title: 'Testing & deployment',
        completed: false,
        value: 5000,
      },
    ],
    notes: [],
    created_at: new Date('2024-01-25'),
    updated_at: new Date('2024-01-25'),
  },
  {
    id: 'proj-16',
    company_id: 'wf',
    title: 'Limitless Redesign',
    completed: false,
    value: 1500,
    tasks: [
      {
        id: 'task-67',
        title: 'No Rush do new design',
        completed: true,
        value: 0,
      },
      {
        id: 'task-95',
        title: 'Shane FUP / Make Sale',
        completed: false,
        value: 0,
      },
    ],
    notes: [],
    created_at: new Date('2024-01-26'),
    updated_at: new Date('2024-01-26'),
  },
  {
    id: 'proj-17',
    company_id: 'wf',
    title: 'LuckyDuckBath.com',
    completed: false,
    value: 2500,
    tasks: [
      { id: 'task-68', title: 'New Design', completed: false, value: 0 },
      { id: 'task-69', title: 'Show customer', completed: false, value: 0 },
      { id: 'task-70', title: 'Shane CLOSE', completed: false, value: 0 },
    ],
    notes: [],
    created_at: new Date('2024-01-27'),
    updated_at: new Date('2024-01-27'),
  },
  {
    id: 'proj-18',
    company_id: 'wf',
    title: 'TeamNTA.com - Sang Cha',
    completed: false,
    value: 2750,
    tasks: [
      { id: 'task-71', title: 'Follow up sale', completed: false, value: 0 },
    ],
    notes: [],
    created_at: new Date('2024-01-28'),
    updated_at: new Date('2024-01-28'),
  },
  {
    id: 'proj-19',
    company_id: 'wf',
    title: 'PetiteStyle.com - Thu Dolittle',
    completed: false,
    value: 2500,
    tasks: [{ id: 'task-72', title: 'Shane FUP', completed: false, value: 0 }],
    notes: [],
    created_at: new Date('2024-01-29'),
    updated_at: new Date('2024-01-29'),
  },
  {
    id: 'proj-20',
    company_id: 'wf',
    title: 'Watson Martial Arts',
    completed: false,
    value: 150,
    tasks: [{ id: 'task-73', title: 'Close Sale', completed: false, value: 0 }],
    notes: [
      {
        id: 'note-watson-1',
        text: 'GET IN TOUCH',
        created_at: new Date('2024-01-30'),
      },
    ],
    created_at: new Date('2024-01-30'),
    updated_at: new Date('2024-01-30'),
  },
  {
    id: 'proj-21',
    company_id: 'wf',
    title: 'Shopware AI - Kevin Brown',
    completed: false,
    value: 0,
    tasks: [
      {
        id: 'task-74',
        title: 'Review AI with Kevin',
        completed: false,
        value: 0,
      },
      { id: 'task-75', title: 'Apply Changes', completed: false, value: 0 },
    ],
    notes: [],
    created_at: new Date('2024-01-31'),
    updated_at: new Date('2024-01-31'),
  },
  {
    id: 'proj-22',
    company_id: 'wf',
    title: 'Mash App',
    completed: false,
    value: 0,
    tasks: [
      { id: 'task-76', title: 'Code App', completed: false, value: 0 },
      { id: 'task-77', title: 'Test', completed: false, value: 0 },
      { id: 'task-78', title: 'Import Data', completed: false, value: 0 },
    ],
    notes: [],
    created_at: new Date('2024-02-01'),
    updated_at: new Date('2024-02-01'),
  },
  {
    id: 'proj-23',
    company_id: 'wf',
    title: 'HLDTaekwondo.com',
    completed: false,
    value: 3500,
    tasks: [
      { id: 'task-79', title: 'Presale FUP', completed: false, value: 0 },
    ],
    notes: [],
    created_at: new Date('2024-02-02'),
    updated_at: new Date('2024-02-02'),
  },
  {
    id: 'proj-24',
    company_id: 'wf',
    title: 'DownHomeInteriors.com',
    completed: false,
    value: 500,
    tasks: [
      { id: 'task-80', title: 'New design', completed: false, value: 0 },
      { id: 'task-81', title: 'Apply Design', completed: false, value: 0 },
      { id: 'task-82', title: 'Twilio Setup', completed: false, value: 0 },
      { id: 'task-83', title: 'Bot Setup', completed: false, value: 0 },
      { id: 'task-84', title: 'FUP Shane', completed: false, value: 0 },
    ],
    notes: [],
    created_at: new Date('2024-02-03'),
    updated_at: new Date('2024-02-03'),
  },
  {
    id: 'proj-25',
    company_id: 'wf',
    title: 'Howell Main Street',
    completed: false,
    value: 0,
    tasks: [
      { id: 'task-85', title: 'Contact lead', completed: false, value: 0 },
    ],
    notes: [],
    created_at: new Date('2024-02-04'),
    updated_at: new Date('2024-02-04'),
  },
  {
    id: 'proj-26',
    company_id: 'wf',
    title: 'The Chosen',
    completed: false,
    value: 0,
    tasks: [
      {
        id: 'task-86',
        title: 'Update Data Brazil',
        completed: false,
        value: 0,
      },
      { id: 'task-87', title: 'Update Data Latem', completed: false, value: 0 },
      {
        id: 'task-88',
        title: 'Update Data APAC ?',
        completed: false,
        value: 0,
      },
      {
        id: 'task-89',
        title: 'Get Steve Approval on Form Process',
        completed: false,
        value: 0,
      },
    ],
    notes: [],
    created_at: new Date('2024-02-04'),
    updated_at: new Date('2024-02-04'),
  },
  {
    id: 'proj-27',
    company_id: 'wf',
    title: 'PrintAtomic.com (JR)',
    completed: false,
    value: 0,
    tasks: [
      {
        id: 'task-90',
        title: 'Redesign as you see fit.',
        completed: false,
        value: 0,
      },
      {
        id: 'task-91',
        title: 'Install DTF sales (builder) at 7.00 per sq foot',
        completed: false,
        value: 0,
      },
      {
        id: 'task-92',
        title:
          'Code must reflect 3.50 paid to us in Sales Manager so he can login to pay',
        completed: false,
        value: 0,
      },
      { id: 'task-93', title: 'Talk to Shane', completed: false, value: 0 },
    ],
    notes: [],
    created_at: new Date('2024-02-05'),
    updated_at: new Date('2024-02-05'),
  },
  {
    id: 'proj-28',
    company_id: 'wf',
    title: 'Roumel | BeReadyMen & BestVitaminsForAll',
    completed: false,
    value: 0,
    tasks: [
      {
        id: 'task-94',
        title: 'Kevin FUP re: SEO Pages',
        completed: false,
        value: 0,
      },
    ],
    notes: [],
    created_at: new Date('2024-02-06'),
    updated_at: new Date('2024-02-06'),
  },
  {
    id: 'proj-29',
    company_id: 'wf',
    title: 'Brammers - Order My Gear',
    completed: false,
    value: 20000,
    tasks: [
      { id: 'task-96', title: 'FUP from quote', completed: false, value: 0 },
    ],
    notes: [],
    created_at: new Date('2024-02-07'),
    updated_at: new Date('2024-02-07'),
  },
  {
    id: 'proj-30',
    company_id: 'wf',
    title: 'Wearhaus - Order My Gear',
    completed: false,
    value: 20000,
    tasks: [
      { id: 'task-97', title: 'FUP from quote', completed: false, value: 0 },
    ],
    notes: [],
    created_at: new Date('2024-02-07'),
    updated_at: new Date('2024-02-07'),
  },
  {
    id: 'proj-31',
    company_id: 'wf',
    title: 'Custom-Transfers.com',
    completed: false,
    value: 0,
    tasks: [
      {
        id: 'task-98',
        title: 'Quote DTF Transfer page',
        completed: false,
        value: 0,
      },
    ],
    notes: [],
    created_at: new Date('2024-02-08'),
    updated_at: new Date('2024-02-08'),
  },
]
